var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import AvisoAlert from "../shared/alert";
import AvisoInput from "../shared/form/input";
import { getXSRF } from "../../src/Services/Shared/FetchService";
class CreateCategoryModal extends PureComponent {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            loading: false,
            categoryName: "",
            active: false,
            error: false,
        };
    }
    componentDidMount() {
        $(`#${this.props.id}`).on("shown.bs.modal", (e) => {
            $("#categoryName").focus();
        });
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.category) {
            this.setState({
                categoryName: nextProps.category.name,
                active: nextProps.category.active,
            });
        }
        else {
            this.setState({ categoryName: "", active: false });
        }
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.state.categoryName) {
                return;
            }
            let url = "/aviso/resourceGuide/createCategory";
            if (this.props.category) {
                url = "/aviso/resourceGuide/editCategory";
            }
            const response = yield fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    name: this.state.categoryName,
                    active: this.state.active,
                    category: this.props.category,
                }),
            });
            const result = yield response.json();
            if (result.success) {
                $(`#${this.props.id}`).modal("hide");
                this.props.onSaveSuccess(result.data.id);
            }
            else {
                this.setState({ error: true });
            }
            console.log(response.url, result);
        });
    }
    onChange(input, value, event) {
        this.setState({ active: value });
    }
    handleKeyPress(e) {
        // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'Event'.
        if (e.key === "Enter") {
            this.save();
        }
    }
    renderActiveCheckbox(category) {
        if (category) {
            const data = {
                property: "active",
                type: "checkbox",
                key: "active",
                currentValue: this.state.active,
                containerClass: "none",
                isRequired: false,
                label: "Active",
                value: this.state.active,
                onChange: this.onChange,
            };
            return _jsx(AvisoInput, Object.assign({}, data));
        }
        return null;
    }
    renderAlerts(props, state) {
        return (_jsxs("span", { children: [_jsxs(AvisoAlert, { show: !props.category, type: "info", children: ["Newly created categories are ", _jsx("b", { children: "inactive" }), " by default. To activate simply edit the category after adding some resources."] }), _jsx(AvisoAlert, { show: state.error, type: "danger", children: "There was an error saving your category. Please reload the page and try again." })] }));
    }
    render() {
        console.log("Category Modal", this.props);
        return (_jsx("div", { className: "modal fade", id: this.props.id, children: _jsx("div", { className: "modal-dialog modal-lg", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { className: "modal-title h5", children: "New Category" }), _jsxs("button", { className: "close", "data-dismiss": "modal", type: "button", children: [_jsx("span", { className: "sr-only", children: "Close modal" }), _jsx("span", { "aria-hidden": "true", children: "\u00D7" })] })] }), _jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { className: "font-weight-bold", htmlFor: "categoryName", children: "Name" }), _jsx("input", { className: "form-control", id: "categoryName", onChange: (event) => this.setState({ categoryName: event.target.value }), 
                                            // @ts-expect-error - TS2322 - Type '(e: Event) => void' is not assignable to type 'KeyboardEventHandler<HTMLInputElement>'.
                                            onKeyPress: this.handleKeyPress, type: "text", value: this.state.categoryName, required: true })] }), this.renderActiveCheckbox(this.props.category), this.renderAlerts(this.props, this.state)] }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { className: "btn btn-primary", onClick: this.save, type: "button", children: [_jsx("span", { "aria-hidden": "true", className: "fa fa-save mr-1" }), "Save"] }), _jsxs("button", { className: "btn btn-outline-secondary", "data-dismiss": "modal", type: "button", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-times mr-1" }), "Close"] })] })] }) }) }));
    }
}
export default CreateCategoryModal;
